<div class="dialog-container">
  <div class="dialog-header">
    <h2 class="dialog-title">Download Cash Statement {{ data.type === 'excel' ? 'Excel' : 'PDF' }}</h2>
  </div>

  <div class="dialog-content">
    <div class="date-fields">
      <div class="date-field">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>From</mat-label>
          <input
            id="fromDate"
            matInput
            [matDatepicker]="fromPicker"
            [(ngModel)]="fromDate"
            [max]="maxDate"
            required
            placeholder="dd/mm/yyyy"
            (dateChange)="onDateChange()"
          />
          <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
          <mat-datepicker #fromPicker></mat-datepicker>
        </mat-form-field>
        <div *ngIf="fromDateError" class="validation-error">
          <span class="error-message">{{ fromDateError }}</span>
        </div>
      </div>

      <div class="date-field">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>To</mat-label>
          <input
            id="toDate"
            matInput
            [matDatepicker]="toPicker"
            [(ngModel)]="toDate"
            [max]="maxDate"
            required
            placeholder="dd/mm/yyyy"
            (dateChange)="onDateChange()"
          />
          <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
          <mat-datepicker #toPicker></mat-datepicker>
        </mat-form-field>
        <div *ngIf="toDateError" class="validation-error">
          <span class="error-message">{{ toDateError }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="dialog-actions">
    <button class="btn cancel_large_btn" (click)="cancel()">
      Cancel
    </button>
    <button class="btn primary_large_btn" (click)="download('ar')" [disabled]="isDateOrderInvalid">
      Download AR
    </button>
    <button class="btn primary_large_btn" (click)="download('en')" [disabled]="isDateOrderInvalid">
      Download EN
    </button>
  </div>
</div>
